import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-page-m01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-m01__inner" }
const _hoisted_5 = { class: "p-the-page-m01__card" }
const _hoisted_6 = { class: "p-the-page-m01__profile" }
const _hoisted_7 = { class: "p-the-page-m01__profile__detail" }
const _hoisted_8 = { class: "p-the-page-m01__profile__detail__icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "p-the-page-m01__profile__detail__basis" }
const _hoisted_11 = { class: "p-the-page-m01__profile__detail__name" }
const _hoisted_12 = { class: "p-the-page-m01__profile__detail__data" }
const _hoisted_13 = { class: "p-the-page-m01__profile__detail__list" }
const _hoisted_14 = { class: "p-the-page-m01__profile__detail__description" }
const _hoisted_15 = { class: "p-the-page-m01__profile__detail__list" }
const _hoisted_16 = { class: "p-the-page-m01__profile__detail__description" }
const _hoisted_17 = { class: "p-the-page-m01__profile__comment" }
const _hoisted_18 = { class: "p-the-page-m01__profile__comment__text" }
const _hoisted_19 = { class: "p-the-page-m01__subpanel" }
const _hoisted_20 = { class: "p-the-page-m01__subpanel__inner p-the-page-m01__subpanel__inner--point" }
const _hoisted_21 = { class: "p-the-page-m01__subpanel__card" }
const _hoisted_22 = { class: "p-the-page-m01__current_point" }
const _hoisted_23 = { class: "p-the-page-m01__current_point__description" }
const _hoisted_24 = { class: "p-the-page-m01__point_condition" }
const _hoisted_25 = { class: "p-the-page-m01__point_condition__data__wrap" }
const _hoisted_26 = { class: "p-the-page-m01__point_condition__data__term" }
const _hoisted_27 = { class: "p-the-page-m01__point_condition__data__term__icon" }
const _hoisted_28 = { class: "p-the-page-m01__point_condition__data__term__name" }
const _hoisted_29 = { class: "p-the-page-m01__point_condition__data__description" }
const _hoisted_30 = { class: "p-the-page-m01__subpanel__inner p-the-page-m01__subpanel__inner--account" }
const _hoisted_31 = { class: "p-the-page-m01__subpanel__card" }
const _hoisted_32 = { class: "p-the-page-m01__list" }
const _hoisted_33 = { class: "p-the-page-m01__list__item" }
const _hoisted_34 = { class: "p-the-page-m01__account__id" }
const _hoisted_35 = { class: "p-the-page-m01__list__item" }
const _hoisted_36 = { class: "p-the-page-m01__list__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_IconComment = _resolveComponent("IconComment")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_M01AccountAnchor = _resolveComponent("M01AccountAnchor")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_ModalMain = _resolveComponent("ModalMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CommonHeading, { class: "p-the-page-m01__heading" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("マイページ", -1)
            ])),
            _: 1,
            __: [0]
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "p-the-page-m01__profile__header",
                style: _normalizeStyle({ backgroundColor: _ctx.colorCode })
              }, null, 4),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_IconUserImage, { size: _ctx.profileIconSize }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.avatar,
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.userInfo.full_name), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("dl", _hoisted_13, [
                      _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "p-the-page-m01__profile__detail__term" }, " 所属グループ： ", -1)),
                      _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.userInfo.group_name), 1)
                    ]),
                    _createElementVNode("dl", _hoisted_15, [
                      _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "p-the-page-m01__profile__detail__term" }, " サービス登録日： ", -1)),
                      _createElementVNode("dd", _hoisted_16, _toDisplayString(_ctx.registrationDate), 1)
                    ])
                  ])
                ]),
                _createVNode(_component_ButtonMain, {
                  tag: "a",
                  href: "/profile-update/",
                  kind: "secondary -border_none -background_none",
                  tabindex: "0",
                  class: "p-the-page-m01__profile__detail__button"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("編集する", -1)
                  ])),
                  _: 1,
                  __: [3]
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_IconBase, {
                  class: "p-the-page-m01__profile__comment__icon",
                  "view-box": "0 0 29 29",
                  width: "29",
                  height: "29"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconComment)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.userInfo.bio ? _ctx.userInfo.bio : "未登録"), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "p-the-page-m01__subpanel__heading" }, "ポイント情報", -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("dl", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "p-the-page-m01__current_point__term" }, " 総ポイント数 ", -1)),
                    _createElementVNode("dd", _hoisted_23, [
                      _createVNode(_component_PointNotation, {
                        "icon-size": 32,
                        "icon-sp-size": 24,
                        point: _ctx.points,
                        unit: _ctx.unit,
                        "font-size": _ctx.currentPointFontSize,
                        "sign-is-exists": false
                      }, null, 8, ["point", "unit", "font-size"])
                    ])
                  ]),
                  _createVNode(_component_ButtonMain, {
                    tag: "a",
                    href: _ctx.urlPointConfirmation + '?redirect_from=my-page',
                    kind: "secondary -border_none -background_none",
                    tabindex: "0",
                    class: "p-the-page-m01__subpanel__button"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("履歴を見る", -1)
                    ])),
                    _: 1,
                    __: [5]
                  }, 8, ["href"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "p-the-page-m01__point_condition__heading" }, " 付与基準 ", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition, key) => {
                      return (_openBlock(), _createElementBlock("dl", {
                        key: key,
                        class: "p-the-page-m01__point_condition__data"
                      }, [
                        _createElementVNode("dt", _hoisted_26, [
                          _createElementVNode("i", _hoisted_27, [
                            _createVNode(_component_IconInvestedRounded, {
                              "bg-color": _ctx.colorCode,
                              "icon-color": "#ffffff",
                              type: condition.icon_type,
                              "icon-size": 36
                            }, null, 8, ["bg-color", "type"])
                          ]),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(condition.name), 1)
                        ]),
                        _createElementVNode("dd", _hoisted_29, [
                          _createVNode(_component_PointNotation, {
                            point: condition.points,
                            unit: _ctx.unit,
                            "font-size": _ctx.conditionPointFontSize,
                            "sign-is-exists": 'plus'
                          }, null, 8, ["point", "unit", "font-size"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_ButtonMain, {
                    tag: "a",
                    href: _ctx.urlGrantCriteria + '?redirect_from=my-page',
                    kind: "secondary -border_none -background_none",
                    tabindex: "0",
                    class: "p-the-page-m01__subpanel__button"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("もっと見る", -1)
                    ])),
                    _: 1,
                    __: [6]
                  }, 8, ["href"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "p-the-page-m01__subpanel__heading" }, "アカウント情報", -1)),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("ul", _hoisted_32, [
                  _createElementVNode("li", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, "ID：" + _toDisplayString(_ctx.userInfo.usingEmployeeId), 1)
                  ]),
                  _createElementVNode("li", _hoisted_35, [
                    _createVNode(_component_M01AccountAnchor, { href: "/mail-delivery-settings/" }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("メール受信設定", -1)
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    _createVNode(_component_M01AccountAnchor, { href: "/my-page/email-settings/" }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("メールアドレスの変更", -1)
                      ])),
                      _: 1,
                      __: [10]
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheFooter),
    (_ctx.modalName === 'profile-update-complete')
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 0 }, {
          head: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode(" プロフィールの変更が ", -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("完了しました。 ", -1)
          ])),
          body: _withCtx(() => [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("OK", -1)
              ])),
              _: 1,
              __: [13]
            }, 8, ["onClickButton"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modalName === 'personalInformationUpdated')
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 1 }, {
          head: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("個人情報の変更が完了しました。", -1)
          ])),
          body: _withCtx(() => [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("OK", -1)
              ])),
              _: 1,
              __: [15]
            }, 8, ["onClickButton"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modalName === 'm06_complete')
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 2 }, {
          head: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("パスワードの変更が完了しました。", -1)
          ])),
          body: _withCtx(() => [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode("OK", -1)
              ])),
              _: 1,
              __: [17]
            }, 8, ["onClickButton"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modalName === 'secretQuestionUpdated')
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 3 }, {
          head: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("秘密の質問の変更が完了しました。", -1)
          ])),
          body: _withCtx(() => [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("OK", -1)
              ])),
              _: 1,
              __: [19]
            }, 8, ["onClickButton"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}